import { List, Record } from 'immutable';
import { Adjustment } from '../../event/models/adjustment';
import { Payment } from '../../event/models/payment';

const PaymentEquationRecord = Record({
  roomCommissions: null,
  adjustments: null,
  prepayment: null,
  totalPaymentRequested: null,
  totalEstimatedTax: null
});

export class PaymentEquation extends PaymentEquationRecord {
  roomCommissions: number;
  adjustments: List<Adjustment>;
  prepayment: Payment;
  totalPaymentRequested: number;
  totalEstimatedTax: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/model/payment-equation.ts